import { NgModule } from '@angular/core'
import { VideoKeyboardControlsDirective } from '../directives/video-keyboard-controls.directive'

@NgModule({
  declarations: [VideoKeyboardControlsDirective],
  exports: [VideoKeyboardControlsDirective]
})
export class KeyboardControlsModule {}
